import React, { useState, useEffect } from "react";
import Textfield from "@atlaskit/textfield";

import { ErrorMessage } from "@atlaskit/form";
import { Box } from "@atlaskit/primitives";
import Textarea from "@atlaskit/textarea";
import { Label } from "@atlaskit/form";

const InputWithValidation = ({ fieldTitle, fieldName, inputValue, onChange, maxChar, minChar, type, stringValidation, className = "", rows = 3 }) => {
  const [value, setValue] = useState("");
  const [showValidationError, setShowValidationError] = useState(false);
  const [validationError, setValidationError] = useState("");

  useEffect(() => {
    if (inputValue !== value) {
      setValue(inputValue);
    }
  }, [inputValue, validationError]);

  const changeValue = (e) => {
    if (runStringValidations(e.target.value)) {
      setShowValidationError(true);
    } //Length validation
    else if (e.target.value && maxChar && e.target.value.length > maxChar) {
      setValidationError(
        "The provided name exceeds the maximum allowable length of " +
          maxChar +
          " characters. Please ensure the name you enter is " +
          maxChar +
          " characters or fewer"
      );
      setShowValidationError(true);
    } else if ((e.target.value && minChar && e.target.value.length < minChar) || e.target.value.length === 0) {
      setValidationError(
        "The provided name has to few chars the minimum allowable length is " +
          minChar +
          " characters. Please ensure the name you enter is " +
          minChar +
          " characters or longer"
      );
      setShowValidationError(true);
      setValue(e.target.value);
      onChange(e);
    } else {
      setShowValidationError(false);
      setValue(e.target.value);
      onChange(e);
    }
  };
  const runStringValidations = (value) => {
    //return false if no validation found
    if (stringValidation === null || stringValidation === undefined || stringValidation === "" || stringValidation == []) {
      return false;
    }
    //Contains
    for (let i = 0; i < stringValidation.length; i++) {
      const item = stringValidation[i];
      if (item.type === "not contain" && value && value.includes(item.word)) {
        setValidationError(item.message);
        return true;
      }
      if (item.type === "eq" && value && value === item.word) {
        setValidationError(item.message);
        return true;
      }
    }
  };

  return (
    <>
      <Label>{fieldTitle}</Label>
      {type === "textarea" ? (
        <Textarea name={fieldName} value={value} isCompact onChange={changeValue} className={className} rows={rows} />
      ) : (
        <Textfield name={fieldName} value={value} isCompact onChange={changeValue} className={className} />
      )}
      {showValidationError && (
        <ErrorMessage>
          <Box as="span">{validationError}</Box>
        </ErrorMessage>
      )}
    </>
  );
};

export default InputWithValidation;
